export default function WalletIcon({
                                       size = 40,
                                   }: {
    size?: number

}) {
    return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="8" fill="url(#paint0_linear_412_1774)"/>
        <path
            d="M32.3335 19.1112V17.3333C32.3335 15.1242 30.5426 13.3333 28.3335 13.3333H25.6668M32.3335 19.1112H25.1112C23.2089 19.1112 21.6668 20.6533 21.6668 22.5556C21.6668 24.4579 23.2089 26 25.1112 26H32.3335M32.3335 19.1112C33.0699 19.1112 33.6668 19.7081 33.6668 20.4445V24.6667C33.6668 25.403 33.0699 26 32.3335 26M32.3335 26V28C32.3335 30.2091 30.5426 32 28.3335 32H11.0002C8.79102 32 7.00016 30.2091 7.00016 28V17.3333C7.00016 15.5917 8.11324 14.1101 9.66683 13.5609M25.6668 13.3333H11.0002C10.5326 13.3333 10.0839 13.4135 9.66683 13.5609M25.6668 13.3333V11.75C25.6668 9.91548 23.8575 8.62884 22.1247 9.2311L9.66683 13.5609"
            stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="26.1668" cy="22.8335" r="2" fill="white"/>
        <defs>
            <linearGradient id="paint0_linear_412_1774" x1="20" y1="0" x2="20" y2="40" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFB950"/>
                <stop offset="0.475" stopColor="#FF7A60"/>
                <stop offset="1" stopColor="#FF3C4A"/>
            </linearGradient>
        </defs>
    </svg>
}